import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ userType, isOpen = false, onClose = () => {} }) => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);


  useEffect(() => {
  // activeLink に一致する a 要素を探してフォーカス
  const selector = `a[href='${activeLink}']`;
  const el = document.querySelector(selector);
  if (isOpen && el) el.focus();
}, [isOpen, activeLink]);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const L = ({ to, children }) => (
    <li>
      <Link to={to} className={activeLink === to ? 'active' : ''} onClick={onClose}>
        {children}
      </Link>
    </li>
  );

  const Section = ({ title, children }) => (
    <>
      <div className="sectionTitle">{title}</div>
      <ul>{children}</ul>
      <hr />
    </>
  );

  const MenuAdmin = () => (
    <>
      <Section title="管理者メニュー">
        <L to="/admin/dashboard">ダッシュボード</L>
        <L to="/admin/events">イベント管理</L>
        <L to="/admin/users">開催者管理</L>
      </Section>

      <Section title="開催者メニュー">
        <L to="/operator/dashboard">イベント一覧</L>
         <L to="/operator/users">ユーザー管理</L>
      </Section>

      <Section title="参加者メニュー">
        <L to="/enduser/dashboard">招待一覧</L>
      </Section>
    </>
  );

  const MenuHost = () => (
    <>
      <Section title="開催者メニュー">
        <L to="/operator/dashboard">イベント一覧</L>
        <L to="/operator/users">ユーザー管理</L>
      </Section>

      <Section title="参加者メニュー">
        <L to="/enduser/dashboard">招待一覧</L>
      </Section>
    </>
  );

  const MenuGuest = () => (
    <>
      <Section title="参加者メニュー">
        <L to="/enduser/dashboard">招待されたイベント</L>
      </Section>
    </>
  );

  const MenuSystem = () => (
    <>
      <Section title="管理者メニュー">
        <L to="/admin/dashboard">ダッシュボード</L>
        <L to="/admin/events">イベント管理</L>
        <L to="/admin/users">開催者管理</L>
         </Section>

      <Section title="開催者メニュー">
        <L to="/operator/dashboard">イベント一覧</L>
        <L to="/operator/users">ユーザー管理</L>
      </Section>

      <Section title="参加者メニュー">
        <L to="/enduser/dashboard">招待一覧</L>
      </Section>
    
      <Section title="システム">
        <L to="/system/settings">設定</L>
      </Section>
    </>
  );


  return (
    <div className="sidebar-container">
      <nav className={`sidebar ${isOpen ? 'open' : ''}`}>
        {userType === 'system' ? <MenuSystem /> : userType === 'admin' ? <MenuAdmin /> : userType === 'operator' ? <MenuHost /> : <MenuGuest />}
      </nav>
      <div className={`sidebar-backdrop ${isOpen ? 'show' : ''}`} onClick={onClose} />
    </div>
  );
};

export default Sidebar;
